export const cookieNames = {
  dataToken: "DATA_TOKEN",
  preAccessToken: "PRE_ACCESS_TOKEN",
  accessToken: "ACCESS_TOKEN",
  refreshToken: "REFRESH_TOKEN",
};
